<template>
    <div>
        <Headers :windowWidth="windowWidth" />
        <div class="t1">Edit Approval Process</div>
        <div class="createAccount_wrap">

                <el-row type="flex" justify="center">
                    <el-col :span="12" >
                        <el-row :gutter="280">
                            <el-col :span="12">
                                <div class="txt1">Module</div>
                                <div class="txt2" v-if="fromData.module == '1'">Account Management</div>
                                <div class="txt2" v-if="fromData.module == '2'">ICC Management</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="txt1">Operation</div>
                                <div class="txt2" v-if="fromData.operation == '1'">Company Account Review</div>
                                <div class="txt2" v-if="fromData.operation == '2'">Agency Account Review</div>
                                <div class="txt2" v-if="fromData.operation == '3'">Transfer Review</div>
                                <div class="txt2" v-if="fromData.operation == '4'">Retirement Review</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <div class="h3">Tier(s)</div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-select v-model="fromData.tier" style="width:100%" clearable placeholder="All">
                            <el-option
                            v-for="item in tierList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12" >
                        <div class="check_box">
                            <div class="check_box_t1">Tier(s) 1</div>
                            <div class="check_box_t2">Approver</div>
                            <el-checkbox-group v-model="fromData.tier1List" text-color="#158869" fill="#158869">
                                <el-checkbox label="Beata"></el-checkbox>
                                <el-checkbox label="Anne"></el-checkbox>
                                <el-checkbox label="Camille"></el-checkbox>
                                <el-checkbox label="Cherry"></el-checkbox>
                                <el-checkbox label="Fern"></el-checkbox>
                            </el-checkbox-group>

                            <div v-if="fromData.tier == '2' || fromData.tier == '3'">
                                <el-divider></el-divider>
                                <div class="check_box_t1">Tier(s) 2</div>
                                <div class="check_box_t2">Approver</div>
                                <el-checkbox-group v-model="fromData.tier2List" text-color="#158869" fill="#158869">
                                    <el-checkbox label="Ailsa"></el-checkbox>
                                    <el-checkbox label="Jack"></el-checkbox>
                                    <el-checkbox label="Michael"></el-checkbox>
                                    <el-checkbox label="Tony"></el-checkbox>
                                    <el-checkbox label="Byntlee"></el-checkbox>
                                </el-checkbox-group>
                            </div>
                            
                            <div v-if="fromData.tier == '3'">
                                <el-divider></el-divider>
                                <div class="check_box_t1">Tier(s) 3</div>
                                <div class="check_box_t2">Approver</div>
                                <el-checkbox-group v-model="fromData.tier3List" text-color="#158869" fill="#158869">
                                    <el-checkbox label="Eliuth"></el-checkbox>
                                    <el-checkbox label="Marquis"></el-checkbox>
                                    <el-checkbox label="Philipe"></el-checkbox>
                                    <el-checkbox label="Quatavius"></el-checkbox>
                                    <el-checkbox label="Siyam"></el-checkbox>
                                </el-checkbox-group>
                            </div>
                            
                        </div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12" class="flex_btn">
                        <el-button class="save back" @click="back">{{$t('createAccount.Back')}}</el-button>
                        <el-button class="save" @click="getapproveProcess">Confirm</el-button>
                    </el-col>
                </el-row>


            
            
        </div>
    </div>
</template>
<script>
import Headers from "@/components/header/index.vue";
import carbon from "@/api/carbon.js";
export default {
    components: { Headers },
    data(){
        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            status:false,
            checkList: [],
            t1List:[],
            t2List:[],
            t3List:[],
            fromData:{
                id:'',
                tier:'1',
                tier1List:[],
                tier2List:[],
                tier3List:[],
            },
            tierList:[
                {
                    value: '1',
                    label: '1'
                },
                {
                    value: '2',
                    label: '2'
                },
                {
                    value: '3',
                    label: '3'
                },
            ],
            form:{
                companyName:'',
                uen:'',
                firstName:'',
                lastName:'',
                username:'',
                phoneNumber:'',
                email:'',
                facilityAddress:'',
                facilityName:'',
                agencyList:[],
                companyList:[],
                password:'',
                confirmPassword:'',
            }
        }
    },
    mounted() {
        this.fromData.id = this.$route.query.id
        this.getapproveProcessinfo()
        let that = this;
        window.onresize = () => {
        return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            (that.windowWidth = document.documentElement.clientWidth), //实时屏幕宽度
            (that.windowHeight = window.fullHeight); // 高
        })();
        };
    },
    methods:{
        save(){
            this.$router.push('/accountDetail')
        },
        getapproveProcess(){
            carbon.getapproveProcess((res) => {
                if(res.code == 200){
                    this.$router.push('/approval')
                }
            },this.fromData);
        },
        getapproveProcessinfo(){
            carbon.getapproveProcessinfo((res) => {
                if(res.code == 200){
                    this.fromData = res.data
                }
            },{id:this.$route.query.id});
        },
        back(){
            this.$router.go(-1)
        },
        changeAgency(){
            console.log(this.checkList)
        },
        changeCompany(){
            console.log(this.checkList)
        },
    }

}
</script>
<style lang="scss" scoped>
.check_box{
    padding: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 24px;
    .check_box_t1{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: bold;
        color: #1E1E1E;
        line-height: 18px;
    }
    .check_box_t2{
        font-size: 15px;
        font-family: ArialMT;
        color: #626262;
        line-height: 17px;
        margin: 50px 0 25px 0;
    }
}
.t1{
    font-size: 40px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 45px;
    margin: 48px auto;
    width: 1534px;
}
.mg_t_40{
    margin-top: 40px;
}
.txt1{
    font-size: 16px;
    font-family: ArialMT;
    color: #626262;
    line-height: 18px;
    margin-bottom: 20px;
}
.tet_box{
    padding: 30px 40px;
    background: #FFFFFF;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tet_1{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: bold;
        color: #1E1E1E;
        line-height: 18px;
    }
    .tet_2{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #00142A;
        line-height: 20px;
        margin: 10px 0;
    }
}
.txt2{
    font-size: 16px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #1E1E1E;
    line-height: 18px;
}
.flex_i{
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: ArialMT;
    color: rgba(0,20,42,0.5);
    line-height: 20px;
    margin-top: 12px;
    .l{
        margin-right: 15px;
    }
    .r{
        text-align: justify;
    }
}
.createAccount_wrap{
    width: 1440px;
    background: #F8F9FA;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
    border-radius: 20px;
    padding: 74px 42px 105px 52px;
    .title{
        font-size: 40px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        text-align: center;
        color: #158869;
        line-height: 45px;
        margin-bottom: 50px;
    }
    .checkbox{
        height: 164px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-top: 60px;
        padding: 20px;
    }
    .save{
        width: 125px;
        height: 44px;
        background: #158869;
        border-radius: 4px;
        font-size: 16px;
        font-family: ArialMT;
        color: #FFFFFF;
    }
    .back{
        background-color: #F8F9FA;
        border-color: #97A5B7;
        color: #97A5B7;
    }
}
.ch_box{
    padding: 32px 40px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 20px;
    .ch_t{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 18px;
        margin-bottom: 12px;
    }
    .mg_t_40{
        margin-top: 40px;
    }
}
.flex_btn{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
}
.c_tl{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
.h3{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: rgba(30,30,30,0.8);
    line-height: 34px;
    margin: 90px 0 20px 0;
}
::v-deep .el-switch__label.is-active{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
::v-deep .el-switch__label{
    font-weight: bold;
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
}
::v-deep .el-form-item__label{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
::v-deep .el-checkbox__label{
    font-size: 14px;
    font-family: ArialMT;
    color: #626262;
}
::v-deep .el-checkbox__inner{
    width: 20px;
    height: 20px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #158869;
    border-color:#158869;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #158869;
    font-size: 14px;
    font-family: ArialMT;
}
::v-deep .el-checkbox__inner::after{
    top: 17%;
    left: 42%;
}
</style>